export default __webpack_public_path__ + "static/media/gearWhite.f09c62c4.svg";